import { iShelfBracketProps, ShelfBrackets } from '@/Engine/Wardrobe/ShelfBrackets';
import { RodHolder } from '@/Engine/Wardrobe/RodHolder';
import { Basket } from '@/Engine/Wardrobe/Basket';
import { IV3D } from '@/Interfaces/v3d';
import { V3dTools } from '@/v3d/common';
import { TrouserRack } from '@/Engine/Wardrobe/TrouserRack';
import { Part, partProps } from '@/Engine/Wardrobe/Part';
import { Shelf } from '@/Engine/Wardrobe/Shelf';
import { moduleItem, wardrobeItem, wardrobeTemplates, xyz } from '@/Interfaces/common';
import { RodCap } from '@/Engine/Wardrobe/RodCap';
import { RackModule } from '@/Engine/Wardrobe/RackModule';
import { clearSeed, randomByUUID } from '@/lib/math';
import { $ } from '@/Engine/stateInstance';
import { Wardrobe } from '@/Engine/Wardrobe/Wardrobe';
import { ShelfAndPanel } from '@/Engine/Wardrobe/ShelfAndPanel';
import { PerforatedPanel } from '@/Engine/Wardrobe/PerforatedPanel';
import { Group, Quaternion, Vector3 } from 'three';
import { TextMesh } from '@/Engine/Ruler/TextMesh';
import { leftArrowName, lineModelName } from '@/Constants/common';
import { InstancingManager } from './InstancingManager';
import _, { template } from 'lodash';



declare let v3d: IV3D;
interface items {
    shelfBracketLeft: ShelfBrackets | null;
    shelfBracketRight: ShelfBrackets | null;
    bracketLeftExtra: Part | null,
    bracketRightExtra: Part | null,
    bracketCenterExtra: Part | null,  // Добавляем центральный аксессуар
    shelf: Part | null;
    pullOutFrame: Part | null;
    rod: Part | null;
    rodHolderLeft: Part | null;
    rodHolderRight: Part | null;
    basket: Basket | null;
    trouserRack: TrouserRack | null;
    rodCap: RodCap | null;
    rodCapLeft: Part | null;
    rodCapRight: Part | null;
    separators: Part[];
}

type shelfItem = ShelfBrackets | Part | RodHolder | Basket | TrouserRack | RodCap;

// type partNames =
//     'shelfBracketLeft' |
//     'shelfBracketRight' |
//     'rod' |
//     'rodHolder' |
//     'basket' |
//     'pullOutFrame' |
//     'trouserRack'

const partNames = [
    'shelfBracketLeft',
    'shelfBracketRight',
    'rod',
    'rodHolderLeft',
    'rodHolderRight',
    'rodCapLeft',
    'rodCapRight',
    'basket',
    'pullOutFrame',
    'trouserRack',
    'shelf',
    ] as const;

// interface partTemplates {
//     [partNames]: iPartTemplate | undefined;
// }

type ObjectFromList<T extends ReadonlyArray<string>, V = string> = {
    [K in (T extends ReadonlyArray<infer U> ? U : never)]: V
};

export interface shelfSetProps extends moduleItem {
    parent: Wardrobe;
    place?: number;
    humanName: string;
    v3dTools: V3dTools;
    rackModule: RackModule;
}

export class ShelfSet extends ShelfAndPanel {
    items: items = {
        shelfBracketLeft: null,
        shelfBracketRight: null,
        bracketLeftExtra: null,
        bracketRightExtra: null,
        bracketCenterExtra: null,  // Добавляем центральный аксессуар
        pullOutFrame: null,
        rod: null,
        rodHolderLeft: null,
        rodHolderRight: null,
        basket: null,
        trouserRack: null,
        shelf: null,
        rodCap: null,
        rodCapLeft: null,
        rodCapRight: null,
        separators: [],
    };

    templates: wardrobeTemplates;
    rodAvailable?: boolean;


    _updateBox() {
        this.box.makeEmpty();
        if (!this.items) return;
        // this.raycastBox.model.removeFromParent();
        Object.entries(this.items).forEach(([ key, item ])=>{
            if (!item) {
                return;
            }


            const worldQuaternion = new Quaternion();
            this.model.getWorldQuaternion(worldQuaternion);
            const yShift = 0;
            // if (this.items.shelf && [ 'gridShelf', 'ldsp' ].includes(this.items.shelf.type)) {
            //     yShift = this.items.shelf.height/2;
            // }
            //

            if ([ 'rod', 'shelf', 'basket', 'pullOutFrame', 'trouserRack'  ].includes(key)) {
                const v1 = new Vector3(
                    item.position.x,
                    item.position.y,
                    item.position.z,
                );
                const v2 = new Vector3(
                    item.position.x + item.width/2,
                    item.position.y - item.height + yShift + (this.items.shelfBracketLeft?.offsets[1] ?? 0)/2,
                    item.position.z + item.depth,
                );

                if (item.type === 'gridShelfBasket') {
                    v2.y = item.position.y - item.height - (this.items.shelfBracketLeft?.height ?? 0) + yShift ;
                }

                this.box.expandByPoint(v1.applyQuaternion(worldQuaternion));
                this.box.expandByPoint(v2.applyQuaternion(worldQuaternion));
            }

            if (key === 'separators' && Array.isArray(item)) {
                item.forEach(subItem => {
                    const v1 = new Vector3(
                        subItem.position.x,
                        subItem.position.y,
                        subItem.position.z,
                    );
                    const v2 = new Vector3(
                        subItem.position.x + subItem.width/2,
                        subItem.position.y - subItem.height + yShift + (this.items.shelfBracketLeft?.offsets[1] ?? 0)/2,
                        subItem.position.z + subItem.depth,
                    );
                    this.box.expandByPoint(v1.applyQuaternion(worldQuaternion));
                    this.box.expandByPoint(v2.applyQuaternion(worldQuaternion));
                });
            }

            if ([ 'shelfBracketLeft', 'shelfBracketRight' ].includes(key)) {
                const v1 = new Vector3(
                    item.position.x,
                    item.position.y,
                    item.position.z,
                );
                const v2 = new Vector3(
                    item.position.x + item.width,
                    item.position.y - item.height + (this.items.shelfBracketLeft?.offsets[1] ?? 0)/2,
                    item.position.z + item.depth,
                );
                this.box.expandByPoint(v1.applyQuaternion(worldQuaternion));
                this.box.expandByPoint(v2.applyQuaternion(worldQuaternion));
            }

            // item.decorModel?.removeFromParent();
        });

        // const worldPos = new Vector3();
        // this.model.getWorldPosition(worldPos);

        // this.model.add(this.raycastBox.model);
        // Object.values(this.items).forEach((item)=>{
        //     if (!item || !item.decorModel) return;
        //     item.model.add(item.decorModel);
        // });
    }

    get raw(): moduleItem {
        return JSON.parse(JSON.stringify(
            {
                uuid: this.uuid,
                templates: this.templates,
                width: this.width,
                height: this.height,
                depth: this.depth,
                type: this.type,
                place: this.place ?? 0,
                humanName: this.humanName,
                position: this.position.toArray(),
                rodAvailable: this.rodAvailable,
                color: this.color,
                side: this.side,
                rackModuleUUID: this.rackModule?.uuid,
                compatibilityDepth: this.compatibilityDepth,
                compatibilityWidth: this.compatibilityWidth,
            },
        ));
    }
    constructor(props: shelfSetProps) {
        super({ ...props, place: props.place ?? 0, type: 'shelf' });
        // { uuid, templates, v3dTools, width, height, depth, parent,
        //     place = 0, humanName, rodAvailable, compatibilityWidth,
        //     compatibilityDepth, color, side }: shelfSetProps
        // { uuid, width, height, depth, raycastBox: true, type: 'shelf',  compatibilityWidth,
        //     compatibilityDepth, color, side, place, humanName, v3dTools, parent }
        this.templates = props.templates;
        this.rodAvailable = props.rodAvailable;
        this.updateModels(this.templates);
        this.updatePartPosition();
        this.addRuler();
        this.computeObb();
    }

    getObject(template: wardrobeItem | undefined) {
        if (!template) return null;
        return this.v3dTools.getObjectByName(template.name);
    }

    setColor(hex: string) {
        this.color = hex.replace('#','');
        Object.entries(this.items).forEach(([ name, item ])=> {
            if (!item) return;
            if (Array.isArray(item)) {
                item.forEach(subItem => subItem.setColor(hex));
            } else {
                item.setColor(hex);
            }
        });
    }

    redMark() {
        this.items.shelf?.redMark();
        this.items.shelfBracketLeft?.redMark();
        this.items.shelfBracketRight?.redMark();
        this.items.basket?.redMark();
        this.items.trouserRack?.redMark();
        this.items.separators.forEach(item => item.redMark());
    }

    noMark() {
        this.items.shelf?.noMark();
        this.items.shelfBracketLeft?.noMark();
        this.items.shelfBracketRight?.noMark();
        this.items.basket?.noMark();
        this.items.trouserRack?.noMark();
        this.items.separators.forEach(item => item.noMark());
    }

    checkCollisions() {
        const error = 0.01;
        const collisions = $.checkAllShelfCollisionWithExclude(this, this.side, []);
        collisions.forEach((collision)=> {
            if (collision.type === 'box') {
                this.redMark();
            }

            if ([ 'panel', 'shelf' ].includes(collision.type)) {
                const collisionShelf = collision as unknown as ShelfSet || PerforatedPanel;
                const shelfDeltaX = Math.abs(this.position.x - collisionShelf.position.x);
                const shelfWidthSum = this.width/2 + collisionShelf.width/2;
                const onSameRack = Math.abs(this.position.x - collisionShelf.position.x) < error;
                const overlay =
                    shelfDeltaX < shelfWidthSum - error || onSameRack;
                const shelfLeftThenCollisionShelf = (this.position.x - collisionShelf.position.x) < error;
                // Коллизия со штангой а текущая полка совместима со штангой
                const shelfAvailableForRod =
                    this.rodAvailable &&
                    !this.items.rod &&
                    !this.items.bracketCenterExtra &&
                    collisionShelf.items?.rod &&
                    !collisionShelf.items?.shelf &&
                    onSameRack;

                // Текущая полка со штангой, а коллизия совместима для установки штанги
                const collisionAvailableForRod =
                    collisionShelf.rodAvailable &&
                    !collisionShelf.items?.rod &&
                    !collisionShelf.items?.bracketCenterExtra &&
                    this.items.rod &&
                    !this.items.shelf &&
                    onSameRack;


                if (overlay && !shelfAvailableForRod && !collisionAvailableForRod)
                    this.redMark();

                // Если штанга накладывается на полку с вешалом по центру
                if (onSameRack &&
                    ((this.items.rod && !this.items.shelf && collisionShelf.items?.bracketCenterExtra) ||
                    (collisionShelf.items?.rod && !collisionShelf.items?.shelf && this.items.bracketCenterExtra))
                ) this.redMark();

                // Полки одинаковые по глубине
                const sameDepth = (
                    Math.abs(this.depth - collisionShelf.depth) < 0.01 &&
                    this.rackModule?.uuid !== collisionShelf.rackModule?.uuid);

                const placeCheck =
                    Math.abs(collisionShelf.place - this.place) >= 3;

                const samePlace = collisionShelf.place === this.place;
                const sameDepthAndPlace = sameDepth && samePlace;
                // Наложение креплений полок
                const bracketsCollision =
                    collisionShelf.type === 'shelf' &&
                    Math.abs(collisionShelf.place - this.place) < 3;


                if (bracketsCollision && !sameDepthAndPlace && !shelfAvailableForRod && !collisionAvailableForRod)
                    this.redMark();



                // Если полка со штангой, а соседня полка несовместима со штангой
                // if (this.items.rod &&
                //     sameDepthAndPlace &&
                //     !collisionShelf.rodAvailable &&
                //     !collisionShelf.items?.rod)
                //         this.redMark();

                // Если соседня полка со штангой, а shelf несовместима со штангой
                // if (!this.rodAvailable &&
                //     !this.items.rod &&
                //     sameDepthAndPlace &&
                //     collisionShelf.items &&
                //     collisionShelf.items?.rod)
                //         this.redMark();

                // Если полка с вешалом по центру
                if (this.items.bracketCenterExtra &&
                    sameDepthAndPlace &&
                    onSameRack
                ) this.redMark();

                // Если полка с крючками слева
                if (this.items.bracketLeftExtra &&
                    sameDepthAndPlace &&
                    !shelfLeftThenCollisionShelf
                ) this.redMark();

                // Если полка с крючками справа
                if (this.items.bracketRightExtra &&
                    sameDepthAndPlace &&
                    shelfLeftThenCollisionShelf
                ) this.redMark();

                // Если соседня полка с крючками слева
                if (
                    sameDepthAndPlace &&
                    collisionShelf.items &&
                    collisionShelf.items?.bracketLeftExtra &&
                    shelfLeftThenCollisionShelf
                ) this.redMark();

                // Если соседня полка с крючками справа
                if (
                    sameDepthAndPlace &&
                    collisionShelf.items &&
                    collisionShelf.items?.bracketRightExtra &&
                    !shelfLeftThenCollisionShelf
                ) this.redMark();

                // Если соседня полка с вешалом по центру
                if (
                    sameDepthAndPlace &&
                    collisionShelf.items &&
                    collisionShelf.items?.bracketCenterExtra &&
                    onSameRack
                ) this.redMark();

                // Если полки на разных стенах
                if (
                    this.side !== collisionShelf.side
                ) this.redMark();

            }
        });
    }

    updatePartPosition() {
        let shiftX = 0;

        if (this.width === 0.6) {
            shiftX = 0.0034;
        }

        if (this.width === 0.9) {
            shiftX = 0.001;
        }
        if (this.items.shelfBracketLeft) {
            this.items.shelfBracketLeft.model.position.x = -this.width / 2 - shiftX;
        }

        if (this.items.shelfBracketRight) {
            this.items.shelfBracketRight.model.position.x = this.width / 2 + shiftX;
        }

        if (this.items.bracketLeftExtra) {
            this.items.bracketLeftExtra.model.position.x = -this.width / 2 - 0.006 - shiftX;
            this.items.bracketLeftExtra.model.position.z = this.items.bracketLeftExtra.depth/2;
            this.items.bracketLeftExtra.model.rotation.y = -Math.PI / 2;
        }

        if (this.items.bracketRightExtra) {
            this.items.bracketRightExtra.model.position.x = this.width / 2 + 0.006 + shiftX;
            this.items.bracketRightExtra.model.position.z = this.items.bracketRightExtra.depth/2;
            this.items.bracketRightExtra.model.rotation.y = Math.PI / 2;
        }

        if (this.items.rodHolderLeft) {
            this.items.rodHolderLeft.model.position.x = -this.width / 2 - shiftX;
            if (this.items.shelfBracketLeft && this.templates.shelfBracketLeft) {
                this.items.rodHolderLeft.model.position.y =  this.templates.shelfBracketLeft.rodHolderPosition[1];
                this.items.rodHolderLeft.model.position.z =  this.templates.shelfBracketLeft.rodHolderPosition[2];
            }
            if (this.items.rod) {
                // this.items.rod.model.position.set(
                //     (this.items.rodHolderLeft.childPosition[0] + this.items.rodHolderRight.childPosition[0]) / 2,
                //     (this.items.rodHolderLeft.childPosition[1] + this.items.rodHolderRight.childPosition[1]) / 2,
                //     (this.items.rodHolderLeft.position.z + this.items.rodHolderRight.position.z) / 2,
                // );
                this.items.rod.model.position.set(
                    0,
                    this.items.rodHolderLeft.childPosition[1] + this.items.rodHolderLeft.model.position.y,
                    this.items.rodHolderLeft.position.z,
                );
                this.items.rodCap?.updatePos(Object.values(this.items.rod.model.position) as xyz);
                this.items.rodCapLeft?.model.position.set(
                    -this.items.rod.width / 2,//TODO
                    this.items.rod.model.position.y,
                    this.items.rod.model.position.z,
                );
                this.items.rodCapRight?.model.position.set(
                    this.items.rod.width / 2,//TODO
                    this.items.rod.model.position.y,
                    this.items.rod.model.position.z,
                );
            }
        }

        if (this.items.rodHolderRight) {
            this.items.rodHolderRight.model.position.x = this.width / 2 + shiftX;
            if (this.items.shelfBracketLeft && this.templates.shelfBracketLeft) {
                this.items.rodHolderRight.model.position.y = this.templates.shelfBracketLeft.rodHolderPosition[1];
                this.items.rodHolderRight.model.position.z = this.templates.shelfBracketLeft.rodHolderPosition[2];
            }
        }

        if (this.items.bracketCenterExtra) {
            this.items.bracketCenterExtra.model.position.x = 0;
            this.items.bracketCenterExtra.model.rotation.y = 0;
            this.items.bracketCenterExtra.model.position.z = this.templates.shelfBracketLeft?.shelfPosition[2] || 0;
        }


        if (this.items.separators && this.items.separators.length > 0) {
            const count = this.items.separators.length;
            this.items.separators.forEach((separator, index) => {
                // смещение от центра
                let shift = 0;
                // расстояние в прутках между разделителями
                let gap = 8;
                if (this.compatibilityWidth === '60') {
                    // в центре попадаем на пруток, смещаем на половинку
                    shift = 0.5;
                    gap = 5;
                }
                // расстояние между прутками
                const gridStep = 0.02;
                const startOffset = - ((2*gap + shift) * gridStep) ;
                const step = gap * gridStep;
                separator.model.position.x = startOffset + index * step;

                separator.model.position.z = this.templates.shelfBracketLeft?.shelfPosition[2] || 0;
                separator.model.rotation.y = 0;
            });
        }
        InstancingManager.getInstance().setNeedsUpdate();

        // docking
        // if (this.items.rodHolderLeft && !this.items.rodHolderRight) {
        //     this.items.rodHolderLeft.model.position.x = -this.width / 2;
        //     if (this.items.shelfBracketLeft)
        //         this.items.rodHolderLeft.model.position.z =  shelfBrackets[0].rodHolderPosition[2];
        //
        //    if (this.items.rod) {
        //         // this.items.rod.model.position.set(
        //         //     this.items.rod.width / 2 - 0.24, //TODO
        //         //     this.items.rodHolderLeft.childPosition[1],
        //         //     this.items.rodHolderLeft.position.z,
        //         // );
        //        this.items.rod.model.position.set(
        //            0,
        //            this.items.rodHolderLeft.childPosition[1],
        //            this.items.rodHolderLeft.position.z,
        //        );
        //        this.items.rodCapLeft?.model.position.set(
        //            -this.items.rod.width / 2,//TODO
        //            this.items.rod.model.position.y,
        //            this.items.rod.model.position.z,
        //        );
        //         //this.items.rodCap?.updatePos(Object.values(this.items.rod.model.position) as xyz);
        //        // this.items.rodCapLeft?.model.position.set(
        //        //     -this.width / 2 - 0.018, //TODO
        //        //     this.items.rodHolderLeft.model.position.y,
        //        //     this.items.rodHolderLeft.model.position.z,
        //        // );
        //     }
        // }

    }

    removeIfExist(item: shelfItem | Part[] | null, itemName: keyof items) {
        if (!item) return;

        if (Array.isArray(item)) {
            item.forEach(subItem => {
                if ((subItem as any).destroy) {
                    (subItem as any).destroy();
                } else if (subItem.model) {
                    subItem.model.removeFromParent();
                }
            });
            this.items[itemName] = [] as any;
        } else {
            if ((item as any).destroy) {
                (item as any).destroy();
            } else if (item.model) {
                item.model.removeFromParent();
            }
            this.items[itemName] = null as any;
        }
    }

    updateModels({
                     shelfBracketLeft,
                     shelfBracketRight,
                     rod,
                     rodHolderLeft,
                     rodHolderRight,
                     rodCap,
                     rodCapLeft,
                     rodCapRight,
                     basket,
                     pullOutFrame,
                     trouserRack,
                     shelf,
                     bracketLeftExtra,
                     bracketRightExtra,
                     bracketCenterExtra,  // Добавляем центральный аксессуар
                     separators,
                 }: wardrobeTemplates) {
        this.items.separators.forEach(separator => {
            if (separator.destroy) {
                separator.destroy();
            } else if (separator.model) {
                separator.model.removeFromParent();
            }
        });
        this.items.separators = [];
        if (separators && Array.isArray(separators)) {
            separators.forEach(separatorTemplate => {
                const separatorObj = this.getObject(separatorTemplate);
                if (separatorObj) {
                    const separator = new Part({
                        model: separatorObj,
                        ...separatorTemplate,
                    } as partProps);
                    this.items.separators.push(separator);
                    this.model.add(separator.model);
                } else {
                    console.warn('Separator mesh not found in scene:', separatorTemplate.name);
                }
            });
        }
        const shelfBracket = shelfBracketLeft ?? shelfBracketRight;
        if (!shelfBracket) {
            console.error('Отсутствует кронштейн полки');
            return;
        }
        const shelfBracketLeftObj = this.getObject(shelfBracketLeft);
        const shelfBracketRightObj = this.getObject(shelfBracketRight);
        const shelfObj = this.getObject(shelf);
        const basketObj = this.getObject(basket);
        const pullOutFrameObj = this.getObject(pullOutFrame);
        const rodObj = this.getObject(rod);
        const rodHolderObj = this.getObject(rodHolderLeft);
        const trouserRackObj = this.getObject(trouserRack);
        const rodCapLeftObj = this.getObject(rodCapLeft);
        const rodCapRightObj = this.getObject(rodCapRight);
        const bracketLeftExtraObj = this.getObject(bracketLeftExtra);
        const bracketRightExtraObj = this.getObject(bracketRightExtra);
        const bracketCenterExtraObj = this.getObject(bracketCenterExtra);  // Добавляем центральный аксессуар


        Object.entries(this.items).forEach(([ name, item ])=>{
            if (name === 'separators') return;
            this.removeIfExist(item, name as keyof items);
        });
        
        if (shelfBracketLeftObj && shelfBracketLeft) {
            this.items.shelfBracketLeft = new ShelfBrackets({
                model: shelfBracketLeftObj,
                ...shelfBracketLeft,
                parent: this,
                isLeft: true,
            } as iShelfBracketProps);
            // this.items.shelfBracketLeft.position;
            if (!shelfBracketLeft.disabled)
                this.model.add(this.items.shelfBracketLeft.model);
        } else {
            console.warn('Не найдена модель кронштейна полки ' + shelfBracketLeft?.name);
            return;
        }
        if (shelfBracketRightObj && shelfBracketRight) {
            this.items.shelfBracketRight = new ShelfBrackets({
                model: shelfBracketRightObj,
                ...shelfBracketRight,
                parent: this,
                isRight: true,
            } as iShelfBracketProps);
            if (!shelfBracketRight.disabled)
                this.model.add(this.items.shelfBracketRight.model);
        } else {
            console.warn('Не найдена модель кронштейна полки ' + shelfBracketRight?.name);
            return;
        }


        if (shelfObj) {
            this.items.shelf = new Shelf({
                model: shelfObj,
                offsets: shelfBracketLeft?.shelfPosition,
                ...shelf,
            } as partProps);
            if (shelf && shelf.childPosition) {
                this.items.shelf.childPosition = shelf.childPosition;
            }
            else {
                this.items.shelf.childPosition = [
                    0,
                    0,
                    this.depth / 2,
                ];
            }

            this.items.shelf.startPoint = [
                -this.items.shelf.width/2,
                this.items.shelf.height,
                0,
            ];
            this.model.add(this.items.shelf.model);
        }

        if (basketObj) {
            this.items.basket = new Basket({
                model: basketObj,
                ...basket,
            } as partProps);
            if (basket && basket.childPosition)
                this.items.basket.childPosition = basket.childPosition;
            else
                this.items.basket.childPosition = [
                    0,
                    -this.height+0.01,
                    this.depth/2,
                ];
            this.model.add(this.items.basket.model);
        }


        if (pullOutFrameObj) {
            this.items.pullOutFrame = new Part({
                model: pullOutFrameObj,
                ...pullOutFrame,
            } as partProps);
            this.model.add(this.items.pullOutFrame.model);
        }

        if (rodHolderObj && rodHolderLeft && !rodHolderLeft.disabled) {
            this.items.rodHolderLeft = new Part({
                ...rodHolderLeft,
                model: rodHolderObj,
                offsets: rodHolderLeft?.offsets,
                rotation: rodHolderRight?.rotation,
                width: this.width,
                height: rodHolderLeft.height,
                depth: rodHolderLeft.depth,
                childPosition: rodHolderLeft?.childPosition,
                uuid: rodHolderLeft.uuid,
                type: '',
                color: this.color,
                side: this.side,
                parent: this,
            });
            this.model.add(this.items.rodHolderLeft.model);
        } else {
            if (this.items.rodHolderLeft)
                this.items.rodHolderLeft.model.removeFromParent();
        }

        if (rodHolderObj && rodHolderRight && !rodHolderRight.disabled) {
            this.items.rodHolderRight = new Part({
                ...rodHolderRight,
                model: rodHolderObj,
                offsets: rodHolderRight?.offsets,
                rotation: rodHolderRight?.rotation,
                width: this.width,
                height: rodHolderRight.height,
                depth: rodHolderRight.depth,
                childPosition: rodHolderRight?.childPosition,
                uuid: rodHolderRight.uuid,
                type: '',
                color: this.color,
                side: this.side,
                parent: this,
            });
            this.model.add(this.items.rodHolderRight.model);
        } else {
            if (this.items.rodHolderRight)
                this.items.rodHolderRight.model.removeFromParent();
        }

        if (rodObj && rod) {
            this.items.rod = new Part({
                model: rodObj,
                ...rod,
            } as partProps);
            this.model.add(this.items.rod.model);
        } else {
            if (this.items.rod)
                this.items.rod.model.removeFromParent();
        }

        this.items.rodCapRight?.model.removeFromParent();
        this.items.rodCapLeft?.model.removeFromParent();
        if (rodCapRightObj && rodCapRight && !rodCapRight.disabled) {
            if (this.items.rodCapRight) {
                this.items.rodCapRight.model.removeFromParent();
            }
            this.items.rodCapRight = new Part({
                ...rodCapRight,
                model: rodCapRightObj,
                offsets: rodCapRight.offsets,
                rotation: rodCapRight.rotation,
                disabled: rodCapRight.disabled,
            });
            this.model.add(this.items.rodCapRight.model);
        } else {
            if (this.items.rodCapRight) {
                this.items.rodCapRight.model.removeFromParent();
            }
        }

        if (rodCapLeftObj && rodCapLeft && !rodCapLeft.disabled) {
            if (this.items.rodCapLeft) {
                this.items.rodCapLeft.model.removeFromParent();
            }
            this.items.rodCapLeft = new Part({
                ...rodCapLeft,
                model: rodCapLeftObj,
                offsets: rodCapLeft?.offsets,
                rotation: rodCapLeft?.rotation,
                disabled: rodCapLeft.disabled,
            });
            this.model.add(this.items.rodCapLeft.model);
        } else {
            if (this.items.rodCapLeft)
                this.items.rodCapLeft.model.removeFromParent();
        }

        /*
        //TODO
        if (rodCapLeftObj && rodCapRightObj && this.items.rod) {
            this.items.rodCap = new RodCap({
                modelLeft: rodCapLeftObj,
                modelRight: rodCapRightObj,
                width: this.items.rod.width as number,
                rodCapLeft: rodCapLeft,
                rodCapRight: rodCapRight,
                position: Object.values(this.items.rod.model.position) as xyz,
            });
            this.model.add(this.items.rodCap.model);
        }
*/
        if (trouserRackObj) {
            this.items.trouserRack = new TrouserRack({
                model: trouserRackObj,
                ...trouserRack,
            } as partProps);
            if (trouserRack && trouserRack.childPosition)
                this.items.trouserRack.childPosition = trouserRack.childPosition;
            else
                this.items.trouserRack.childPosition = [
                    0,
                    -0.025,
                    this.depth/2,
                ];
            this.model.add(this.items.trouserRack.model);
        } else {
            if (this.items.trouserRack)
                this.model.remove(this.items.trouserRack.model);
            this.items.trouserRack = null;
        }

        if (bracketLeftExtraObj) {
            this.items.bracketLeftExtra = new Part({
                model: bracketLeftExtraObj,
                ...bracketLeftExtra,
            } as partProps);
            this.model.add(this.items.bracketLeftExtra.model);
        }

        if (bracketRightExtraObj) {
            this.items.bracketRightExtra = new Part({
                model: bracketRightExtraObj,
                ...bracketRightExtra,
            } as partProps);
            this.model.add(this.items.bracketRightExtra.model);
        }

        if (bracketCenterExtraObj) {
            this.items.bracketCenterExtra = new Part({
                model: bracketCenterExtraObj,
                ...bracketCenterExtra,
            } as partProps);
            this.model.add(this.items.bracketCenterExtra.model);
        }

        this.startPoint = [
            -this.width/2,
            -this.height,
            0,
        ];
        this.updatePartPosition();

    }

    // set startPoint(pos: xyz) {
    //     super.startPoint = pos;
    //     // this.selectionBox.select(this);
    //     // this._startPoint = pos;
    //     const boxPos = new Vector3(
    //         pos[0],
    //         pos[1] + this.height / 2,
    //         pos[2],
    //     );
    //     this.raycastBox.model.position.set(...boxPos);
    // }

    // replaceRod(rodNew: wardrobeItem | undefined) {
    //     const rodNewObj = this.getObject(rodNew);
    //     if (rodNewObj && rodNew) {
    //         if (this.items.rod) {
    //             this.items.rod.model.removeFromParent();
    //         }
    //         this.items.rod = new Part({
    //             model: rodNewObj,
    //             ...rodNew,
    //         } as partProps);
    //         this.model.add(this.items.rod.model);
    //     } else {
    //         if (this.items.rod)
    //             this.items.rod.model.removeFromParent();
    //     }
    //     this.updatePartPosition();
    //
    // }

    clearDecor() {
        Object.values(this.items).forEach((item)=>{
            if (Array.isArray(item)) {
                item.forEach((subItem) => {
                    subItem?.decorModel?.clear();
                });
            } else {
                item?.decorModel?.clear();
            }
        });
    }




    addDecor() {
        const decors = $.decorModelsBySurface;
        const upShelfDistance = this.getLowerShelfDistance(this.rays.up);
        const downShelfDistance = this.getLowerShelfDistance(this.rays.down);
        this.clearDecor();
        let decor = null;
        clearSeed(this.uuid);
        if (this.items.shelf) {
            if (this.items.shelf.type === 'shoeRack')
                decor = this.getDecor(decors, 'shoemakers');
            else
                decor = this.getDecor(decors, 'shelves', upShelfDistance);

            if (decor) {
                this.items.shelf.decorModel.add(decor.model.clone());
                this.items.shelf.decorModel.position.set(...this.items.shelf.childPosition);
            }
        }
        if (this.items.basket) {
            const decor = this.getDecor(decors, 'baskets', upShelfDistance + this.items.basket.height);
            if (decor) {
                this.items.basket.decorModel.add(decor.model.clone());
                this.items.basket.decorModel.position.set(...this.items.basket.childPosition);
            }
        }
        if (this.items.rod) {
            const step = 0.2;
            const randomStep = 0.1;
            for (let i = step/2; i<=this.items.rod.width - step/2; i+=(step + randomByUUID(this.uuid)*randomStep)) {
                const decor = this.getDecor(decors, 'barbell', downShelfDistance);
                if (!decor) return;
                const model = decor.model.clone();
                model.position.set(
                    -this.items.rod.width/2 + i,
                    0.013,
                    0,
                );
                model.rotation.y = (0.5-randomByUUID(this.uuid))*0.28;// + (randomByUUID(this.uuid) < 0.3 ? Math.PI : 0);
                this.items.rod.decorModel.add(model);
            }

        }
        if (this.items.trouserRack) {

            const isWide = Math.abs(this.items.trouserRack.width - 0.6) < 0.1;
            const step = isWide?0.05:0.058;
            const firstStep = isWide?0.018:0.014;
            for (let i = step+firstStep; i<=this.items.trouserRack.width - step-firstStep; i+=step) {
                if (randomByUUID(this.uuid) < 0.3) continue;
                const decor = this.getDecor(decors, 'trousers', downShelfDistance);
                if (!decor) return;
                const model = decor.model.clone();
                model.position.set(
                    -this.items.trouserRack.width/2 + i,
                    this.items.trouserRack.childPosition[1],
                    this.items.trouserRack.childPosition[2],
                );
                // model.rotation.y = (0.5-randomByUUID(this.uuid))*0.2 + (randomByUUID(this.uuid) < 0.5 ? 0 : Math.PI);
                this.items.trouserRack.decorModel.add(model);
            }
        }
    }



    computeObb = () => {
        this.addRuler();
        this._updateBox();
        this.worldBox = this.box.clone(); //.applyMatrix4(this.model.matrixWorld);


        // if (this.items.shelf && this.items.rod) {
        //     const sizes = new Vector3();
        //     this.box.getSize(sizes);
        //     super.computeObb(new Vector3(0, -sizes.y/2, sizes.z/2));
        //     return;
        // }
        if (this.items.shelfBracketLeft) {
            let yShift = 0;
            this._updateBox();
            const worldQuaternion = new Quaternion();
            this.model.getWorldQuaternion(worldQuaternion);
            const sizes = new Vector3();
            this.box.getSize(sizes);
            sizes.applyQuaternion(worldQuaternion);

            if (this.items.shelf && this.items.shelf.type === 'gridShelfBasket') {
                yShift = this.items.shelf?.height || 0;

            }
            super.computeObb(new Vector3(
                0,
                -Math.abs(sizes.y/2) + this.items.shelfBracketLeft.offsets[1] + yShift,
                Math.abs(sizes.z/2)-0.01, // смещение на глубину стойки
            ).applyQuaternion(worldQuaternion));
            return;
        }

        super.computeObb();

    };

    destroy() {
        Object.entries(this.items).forEach(([ name, item ]) => {
            this.removeIfExist(item, name as keyof items);
        });
        this.model.clear();
        this.model.removeFromParent();
    }
}
